export enum EActivity {
  myActivity = 'activity/getActivityLog',
  myProgress = 'activity/getProgressMeter',
  updateData = 'activity/updateData',
  myRewardPoints = 'activity/getRewardPoints',
  updateRewardPoints = 'activity/updateRewardPoints',
  myDailyStreak = 'activity/getDailyStreak',
  myRewardPointsLog = 'activity/getMyRewardPointsLog',
}
